// TSS vite/03 §"Query keys convention".

export const semenKeys = {
    all:    ['semen'],
    list:   (filters) => ['semen', 'list', filters],
    detail: (id)      => ['semen', 'detail', id],
};
